<template>
  <div class="news">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <div class="queryData">
          <el-input
            style="width: 150px"
            placeholder="请输入标题"
            v-model.trim="queryData.keyWord"
            @keyup.enter.native="getDataList(true)"
            clearable
          >
          </el-input>
          <el-select
            v-model="queryData.status"
            class="inputS"
            placeholder="状态"
            @change="getDataList(true)"
            clearable
          >
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-button type="success" @click="getDataList">查询</el-button>
          <el-button class="inputR" type="primary" @click="addOrEditPopup(0)"
            >新增</el-button
          >
        </div>
      </div>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        v-loading="loadingFlag"
        element-loading-text="正在拼命加载中"
        element-loading-spinner="el-icon-loading"
        stripe
      >
        <el-table-column type="index" label="#" width="50"></el-table-column>
        <el-table-column prop="newsTypeName" label="新闻类型" min-width="100">
        </el-table-column>
        <el-table-column prop="title" label="新闻标题" min-width="300">
        </el-table-column>
        <!-- <el-table-column prop="sort" label="排序" min-width="50">
        </el-table-column> -->
        <el-table-column prop="top" label="打开方式" min-width="100">
          <template slot-scope="scope">
            <el-tag effect="plain" type="success" v-if="scope.row.openMode == 1"
              >内容</el-tag
            >
            <el-tag effect="plain" type="warning" v-if="scope.row.openMode == 2"
              >外部链接</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column prop="top" label="置顶" min-width="80">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.top == true">是</el-tag>
            <el-tag type="danger" v-if="scope.row.top == false">否</el-tag>
          </template>
          <!-- <template slot-scope="scope">
            <el-switch
              v-model="scope.row.top"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="changeTopping($event, scope.row.id)"
            >
            </el-switch> -->
          <!-- </template> -->
        </el-table-column>
        <el-table-column prop="status" label="状态" min-width="80">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status == 1" type="success">启用</el-tag>
            <el-tag type="danger" v-if="scope.row.status == 2">禁用</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" min-width="180">
          <template slot-scope="scope">
            <div>{{ VueDateFormat(scope.row.createTime) }}</div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" min-width="120">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="addOrEditPopup(scope.row.id)"
              style="marin-right: 20px"
              >编辑</el-button
            >
            <span class="operationLine">|</span>
            <el-button type="text" @click="baseDeleteById(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="getDataListSizeChange"
        @current-change="getDataListCurrentChange"
        :current-page="queryData.current"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="queryData.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [],
      queryData: {
        current: 1,
        size: 10,
        keyWord: "",
        status: "",
        type: 1,
      },
      total: 0,
      loadingFlag: false,
      statusList: [
        {
          label: "启用",
          value: 1,
        },
        {
          label: "禁用",
          value: 2,
        },
      ],
    };
  },
  created() {},
  mounted() {
    this.getDataList();
  },
  methods: {
    // 新增
    addOrEditPopup(id) {
      this.$router.push({
        name: "NewsListAddOrEdit",
        query: {
          id: id,
        },
      });
    },
    // changeTopping(e, id) {
    //   if (e) {
    //     this.$http.post(`/news/setProductTopById?id=${id}`).then((res) => {
    //       if (res.data.code == 200) {
    //         this.getDataList();
    //       }
    //     });
    //   } else {
    //     this.$http
    //       .put(`/news/updateById`, {
    //         id,
    //         top: e,
    //       })
    //       .then((res) => {
    //         if (res.data.code == 200) {
    //           this.getDataList();
    //         }
    //       });
    //   }
    // },
    /**
     * 删除数据
     */
    baseDeleteById(id) {
      if (id) {
        this.$confirm("是否删除所选择的数据?", "温馨提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$http.delete(`/news/baseDeleteById/${id}`).then((res) => {
              if (res.data.code == 200) {
                this.getDataList();
                this.$VueMessage({
                  type: "success",
                  message: "删除成功!",
                });
              } else {
                this.$VueMessage({
                  message: res.data.msg,
                  type: "warning",
                });
              }
            });
          })
          .catch(() => {
            this.$VueMessage({
              type: "info",
              message: "已取消删除",
            });
          });
      }
    },
    // 查询
    getDataList(flag) {
      let data = this.queryData;
      if (flag) data.current = 1;
      this.loadingFlag = true;
      this.$http
        // .post(`/sys-banner/page`, this.$guolv(this.queryData))
        .get(`/news/getSelectPage`, {
          params: data,
        })
        .then((res) => {
          this.loadingFlag = false;
          if (res.data.code == 200) {
            let data = res.data.data;
            if (data) {
              let list = data.records;
              this.tableData = list;
              this.total = data.total;
            } else {
              this.tableData = [];
              this.total = 0;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getDataListSizeChange(val) {
      this.queryData.size = val;
      this.getDataList(true);
    },
    getDataListCurrentChange(val) {
      this.queryData.current = val;
      this.getDataList();
    },
  },
};
</script>